<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-page-header @back="onBack" title="" content="幫助手冊">
        </el-page-header>
      </el-col>
    </el-row>
    <div class="page-box">
      <el-tabs v-model="activeName">
        <el-tab-pane label="英文" name="first"></el-tab-pane>
        <el-tab-pane label="中文" name="second"></el-tab-pane>
      </el-tabs>
      <common-problem-chinese2 :list="chineseList" v-show="activeName == 'second'"></common-problem-chinese2>
      <common-problem-english2 :list="englishList" v-show="activeName == 'first'"></common-problem-english2>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBack">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import commonProblemChinese2 from "./components/common-problem-chinese2";
import commonProblemEnglish2 from "./components/common-problem-english2";
import { getWebFaqs, addWebFaqs } from "@/api/setting";
export default {
  components: {
    commonProblemChinese2,
    commonProblemEnglish2,
  },
  data() {
    return {
      activeName: "first",
      englishList:[],
      chineseList:[],
    };
  },
  created() {
    this.getWebFaqChineseList();
    this.getWebFaqEnglishList();
  },
  methods: {
    onSubmit() {
      this.addWebFaqs();
    },
    addWebFaqs() {
      let from = {
        faqs: [
          ...this.englishList,
          ...this.chineseList,
        ],
      }
      addWebFaqs(from).then(() => {
        this.getWebFaqChineseList();
        this.getWebFaqEnglishList();
        this.$message({
          message: "提交成功",
          type: "success",
        });
      });
    },
   
    getWebFaqChineseList() {
      let from = {
         lang:0,
         type:1,
      }
      getWebFaqs(from).then((v) => {
        this.chineseList = v.data;

      });
    },
    getWebFaqEnglishList() {
      let from = {
         lang:1,
         type:1,
      }
      getWebFaqs(from).then((v) => {
        this.englishList = v.data;

      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
}
.form-box {
  width: 400px;
}
.unit-list {
  margin-bottom: 20px;
}
.plus-outline-add {
  display: inline-block;
}
</style>